// src/hooks/useDocumentList.ts
import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import { getDocumentList } from '../services/documentService';
import type { DocumentSummary } from '../services/documentService';

/**
 * 全ドキュメントのサマリー一覧を取得するフック
 */
export const useDocumentList = () => {
  return useQuery<DocumentSummary[], Error>({
    queryKey: ['documentList'],
    queryFn: async (): Promise<DocumentSummary[]> => {
      const res: AxiosResponse<DocumentSummary[]> = await getDocumentList();
      return res.data;
    },
    staleTime: 5 * 60 * 1000, // 5 分間はキャッシュを新鮮とみなす
    retry: 1,
    refetchOnWindowFocus: false,
  });
};
